import { Box, Card, CardContent, Skeleton } from '@mui/material';

// Pre-computed arrays to avoid Array.from in JSX
const LEGEND_ITEMS = [1, 2, 3];
const TIME_RANGE_ITEMS = [1, 2, 3, 4, 5, 6];

const LegendSkeletonItem = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexShrink: 0 }}>
    <Skeleton variant="circular" width={8} height={8} />
    <Skeleton variant="text" width={80} height={20} />
  </Box>
);

const TimeRangeSkeletonItem = () => (
  <Skeleton variant="rounded" width={40} height={24} sx={{ borderRadius: 4, flexShrink: 0 }} />
);

export const GraphSkeleton = () => {
  return (
    <Card>
      <CardContent>
        {/* Legend - mirrors PriceChartHeader, left-aligned above the chart */}
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 4.5 }}>
          {LEGEND_ITEMS.map((item) => (
            <LegendSkeletonItem key={item} />
          ))}
        </Box>

        <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 2 }} />

        {/* Time Range Selector - bottom right of chart, mirrors MarketChartSection */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Box sx={{ display: 'flex', gap: 0.75, overflowX: 'auto' }}>
            {TIME_RANGE_ITEMS.map((item) => (
              <TimeRangeSkeletonItem key={item} />
            ))}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default GraphSkeleton;
